export default function initMap(idSelector) {
    let map = new ymaps.Map(idSelector, {center: [55.755348, 37.759524], zoom: 14});
    let placemark = new ymaps.Placemark([55.755348,37.759524], {iconContent: 'F'}, {
        iconLayout: 'default#imageWithContent',
        iconImageHref: '/foxfishing_v2/img/delivery-pickup-map-placemark.svg',
        iconImageSize: [48, 48],
        iconImageOffset: [-24, -24],
        iconContentOffset: [20, 16],
        iconContentLayout: ymaps.templateLayoutFactory.createClass('<div style="font-size: 16px; color: #FFFFFF; font-weight: bold;">$[properties.iconContent]</div>'),
    });
    map.geoObjects.add(placemark);
}